import { defineStore } from 'pinia'
import fetchData, { HttpMethod } from '@/model/Storage'
import { BackendLink, LinkType, PermissionsState, LinksResponse } from '@/model/types'

// Helper function to map backend links to frontend link structure
const mapBackendLinkToFrontendLink = (backendLink: BackendLink): LinkType => {
    // Mapping from backend link relations to frontend titles
    const titleMap: Record<string, string> = {
        '/timesheet': 'Timesheet',
        '/admin': 'Admin Panel',
        '/contacts': 'Contacts',
        '/offers': 'Offers',
        '/tiptel': 'Tiptel',
        '/visa': 'Visa',
        '/nice': 'Nice',
        // ... other mappings
    }

    // Create and return the frontend link object
    return {
        title: titleMap[backendLink.rel] || 'Unknown', // Default title if not mapped
        href: backendLink.rel,
    }
}

// Store definition for managing permissions
export const usePermissionsStore = defineStore('PermissionsStore', {
    state: (): PermissionsState => ({
        links: [],
        loading: false,
    }),

    persist: true, // Enabling persistence for the store

    actions: {
        async fetchUserLinks(): Promise<void> {
            this.loading = true
            try {
                const response: LinksResponse = await fetchData({
                    method: HttpMethod.GET,
                    endpoint: 'users/links',
                })

                // Validate and map the response to frontend structure
                if (!response || !response.links || !Array.isArray(response.links)) {
                    throw new Error('Invalid response structure')
                }

                this.links = response.links.map(mapBackendLinkToFrontendLink)
            } catch (error) {
                console.error('Error fetching user links:', error)
                this.links = [] // Resetting links in case of an error
            } finally {
                this.loading = false
                //console.log('Fetched links:', this.links) // Logging the fetched links
            }
        },
    },
})
